import axios from '@/utils/http'

/**
 * 获取公共菜品库数据
 * @param {} params
 */
export function getCommonDishe (params) {
  return axios({
    url: '/AccountManageService/CommonMenuManage/GetCommonMenus',
    method: 'GET',
    params: params
  })
}

/**
 * 模糊搜索食材
 * @param {*} params
 */
export function getComponentByName (params) {
  return axios({
    url: '/AccountManageService/CommonMenuManage/GetFoodByName',
    method: 'GET',
    params: params
  })
}

/**
 * 添加菜品
 * @param {*} params
 */
export function addDishe (params) {
  return axios({
    url: '/AccountManageService/CommonMenuManage/AddMenu',
    method: 'POST',
    data: params,
    processData: false,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 编辑菜品
 * @param {*} params
 */
export function editDishe (params) {
  return axios({
    url: '/AccountManageService/CommonMenuManage/EditMenu',
    method: 'POST',
    data: params,
    processData: false,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 根据名称获取菜品
 * @param {*} params
 */
export function getMenuByName (params) {
  return axios({
    url: '/AccountManageService/CommonPackageManage/GetCommonMenuByName',
    method: 'GET',
    params: params
  })
}

/**
 * 根据Id获取菜品
 * @param {*} params
 */
export function getMenuById (params) {
  return axios({
    url: '/AccountManageService/CommonMenuManage/GetCommonMenuFoods',
    method: 'GET',
    params: params
  })
}
